var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDAppRelease = function SvgDAppRelease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 540 360"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 360,
    fill: "#FCF7F7",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M344.459 137.096c-.936 0-1.825-.187-2.511-.593l-56.457-32.588c-.733-.421-1.123-1.029-1.123-1.7 0-.78.546-1.545 1.513-2.091l55.692-32.151c1.7-.983 4.212-1.076 5.694-.219l56.456 32.589c.733.421 1.123 1.029 1.123 1.7 0 .78-.546 1.545-1.513 2.091l-55.692 32.151c-.92.546-2.074.811-3.182.811m-2.075-1.341c1.202.702 3.417.592 4.821-.219l55.691-32.151c.671-.39 1.077-.889 1.077-1.342 0-.452-.375-.764-.687-.936L346.83 68.519c-1.201-.702-3.416-.593-4.82.218l-55.692 32.152c-.671.39-1.076.889-1.076 1.341 0 .453.374.765.686.936z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__a)",
    d: "M404.847 83.884v6.98l-60.423 34.891L284 90.864v-6.98z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__b)",
    d: "M404.847 83.884v6.98l-60.423 34.891L284 90.864v-6.98z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__c)",
    d: "M344.424 118.767 284 83.884 344.424 49l60.423 34.884z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m344.424 117.952-59.713-34.48-.711.412 60.424 34.883 60.423-34.883-.71-.404z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m344.427 110.725-46.472-26.834 46.472-26.827 46.471 26.827z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__d)",
    d: "m344.426 110.725-46.472-26.834 46.472-26.827 46.472 26.827z",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__e)",
    d: "m344.427 50.294 46.471 26.834v6.763l-46.471-26.834z",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__f)",
    d: "M344.426 57.057 297.954 83.89v-6.763l46.472-26.834v6.763z",
    opacity: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__g)",
    d: "m344.426 103.955-46.472-26.827 46.472-26.834 46.472 26.834z",
    opacity: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m344.426 87.849-18.568-10.72 18.568-10.72 18.568 10.72z",
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m344.426 67.388 17.715 10.234.853-.494-18.568-10.72-18.568 10.72.853.494z",
    opacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__h)",
    d: "M344.427 103.955v6.77l46.471-26.834v-6.763z",
    opacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__i)",
    d: "M297.954 77.128v6.763l46.472 26.834v-6.77z",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m344.427 103.222-45.836-26.468-.636.374 46.472 26.827 46.471-26.827-.635-.374z",
    opacity: 0.8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M113.459 273.096c-.936 0-1.825-.187-2.511-.593l-56.457-32.588c-.733-.421-1.123-1.029-1.123-1.7 0-.78.546-1.545 1.513-2.091l55.692-32.151c1.7-.983 4.212-1.076 5.694-.218l56.456 32.588c.733.421 1.123 1.029 1.123 1.7 0 .78-.546 1.545-1.513 2.091l-55.692 32.151c-.92.546-2.074.811-3.182.811m-2.075-1.341c1.202.702 3.417.592 4.821-.219l55.691-32.151c.671-.39 1.077-.889 1.077-1.342 0-.452-.375-.764-.687-.936l-56.456-32.588c-1.201-.702-3.416-.593-4.82.218l-55.692 32.152c-.67.39-1.076.889-1.076 1.341 0 .453.374.765.686.936z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__j)",
    d: "M173.847 219.884v6.98l-60.423 34.891L53 226.864v-6.98z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__k)",
    d: "M173.847 219.884v6.98l-60.423 34.891L53 226.864v-6.98z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__l)",
    d: "M113.424 254.767 53 219.884 113.424 185l60.423 34.884z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m113.424 253.952-59.713-34.48-.711.412 60.424 34.883 60.423-34.883-.71-.404z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m113.427 246.725-46.472-26.834 46.472-26.827 46.471 26.827z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__m)",
    d: "m113.426 246.725-46.472-26.834 46.472-26.827 46.472 26.827z",
    opacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__n)",
    d: "m113.426 186.294 46.471 26.834v6.763l-46.471-26.834z",
    opacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__o)",
    d: "m113.426 193.057-46.472 26.834v-6.763l46.472-26.834z",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__p)",
    d: "m113.426 239.955-46.472-26.827 46.472-26.834 46.472 26.834z",
    opacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m113.426 223.849-18.568-10.721 18.568-10.72 18.568 10.72z",
    opacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m113.426 203.388 17.715 10.234.853-.494-18.568-10.72-18.568 10.72.853.494z",
    opacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__q)",
    d: "M113.426 239.955v6.77l46.471-26.834v-6.763z",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__r)",
    d: "M66.954 213.128v6.763l46.472 26.834v-6.77z",
    opacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m113.427 239.222-45.836-26.468-.636.374 46.472 26.827 46.471-26.827-.635-.374z",
    opacity: 0.8
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#9EA1B6",
    d: "m352.089 157.793-19.64-116.585 1.569-.666-2.378-1.355v.024c-.452-.31-1.118-.286-1.831.119l-157.056 90.666c-1.284.738-2.259 2.664-2.045 3.995l19.808 117.513c.095.618.404 1.022.832 1.189l2.33 1.331.404-2.164-.142.048 156.104-90.12c1.285-.737 2.283-2.663 2.045-3.995"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABACC0",
    d: "m173.633 133.183-2.592-1.141c-.285.665-.428 1.355-.333 1.949l19.807 117.513c.096.618.405 1.022.833 1.189l2.33 1.331.404-2.163-.143.047 7.895-4.565z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "m352.518 163.215-157.056 90.667c-1.213.689-2.259.285-2.473-.951l-19.807-117.513c-.238-1.331.761-3.234 2.045-3.995l157.056-90.666c1.212-.69 2.258-.286 2.472.95l19.808 117.513c.214 1.332-.761 3.234-2.045 3.995"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E5891",
    d: "m330.238 48.247-151.396 87.385 18.761 110.689 151.301-87.338z",
    opacity: 0.51
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__s)",
    d: "m451.244 218.833-8.56 4.471-85.935-49.626c-1.427-.832-3.947-.737-5.612.238l-148.234 85.578c-1.427-.784-7.894-3.899-7.894-3.899l3.139 8.179h.023c.119.357.405.714.88.975l90.524 52.265c1.427.832 3.947.737 5.612-.238l151.682-87.575c.69-.404 1.094-.88 1.284-1.356z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__t)",
    d: "m451.244 218.833-8.56 4.471-85.935-49.626c-1.427-.832-3.947-.737-5.612.238l-148.234 85.578c-1.427-.784-7.894-3.899-7.894-3.899l3.139 8.179h.023c.119.357.405.714.88.975l90.524 52.265c1.427.832 3.947.737 5.612-.238l151.682-87.575c.69-.404 1.094-.88 1.284-1.356z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__u)",
    d: "m449.912 220.26-155.463 89.763c-1.712.975-4.28 1.094-5.754.238l-92.759-53.549c-1.475-.856-1.284-2.33.404-3.329l155.463-89.763c1.712-.975 4.28-1.094 5.754-.238l92.759 53.572c1.475.833 1.308 2.307-.404 3.306"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__v)",
    d: "m449.912 220.26-155.463 89.763c-1.712.975-4.28 1.094-5.754.238l-92.759-53.549c-1.475-.856-1.284-2.33.404-3.329l155.463-89.763c1.712-.975 4.28-1.094 5.754-.238l92.759 53.572c1.475.833 1.308 2.307-.404 3.306"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m449.911 219.356-155.463 89.763c-1.712.975-4.28 1.094-5.754.238l-92.76-53.549c-.475-.285-.761-.618-.903-.998-.238.689.047 1.403.903 1.902l92.76 53.549c1.474.856 4.042.737 5.754-.238l155.463-89.763c1.141-.666 1.593-1.546 1.308-2.307-.167.499-.595.999-1.308 1.403"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M247.558 290.596v-1.712c0-.166.095-.238.214-.167l6.016 3.472c.118.071.214.262.214.428v1.712c0 .167-.096.238-.214.167l-6.016-3.472c-.119-.071-.214-.262-.214-.428m8.989 5.184v-1.712c0-.167.095-.238.214-.167l6.016 3.472c.119.071.214.261.214.428v1.712c0 .166-.095.238-.214.166l-6.016-3.471c-.119-.072-.214-.262-.214-.428"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#ADB1F2",
    d: "m220.118 251.671 129.187-74.593a2.77 2.77 0 0 1 2.782 0l46.011 26.608a.983.983 0 0 1 0 1.712l-129.116 74.545c-.856.5-1.926.5-2.782 0l-46.082-26.56a.983.983 0 0 1 0-1.712"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__w)",
    d: "m220.118 251.671 129.187-74.593a2.77 2.77 0 0 1 2.782 0l46.011 26.608a.983.983 0 0 1 0 1.712l-129.116 74.545c-.856.5-1.926.5-2.782 0l-46.082-26.56a.983.983 0 0 1 0-1.712"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8DA5",
    d: "m220.119 253.383.451.261 128.736-74.331a2.77 2.77 0 0 1 2.782 0l45.536 26.347.452-.262a.984.984 0 0 0 0-1.712l-46.011-26.608a2.77 2.77 0 0 0-2.782 0l-129.188 74.593c-.642.38-.642 1.331.024 1.712"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "m355.564 183.831-112.21 64.773-4.994-2.878 112.21-64.772zm12.244 7.062-105.267 60.754-4.993-2.877 105.267-60.754zm7.964 4.59-123.933 71.549-4.993-2.877 123.932-71.549zm7.969 4.613-123.933 71.549-4.994-2.901 123.933-71.549zm7.964 4.589-123.932 71.549-4.994-2.877 123.933-71.549zm-155.129 47.842-4.994 2.877-4.993-2.877 4.993-2.878zm17.593 3.971-10.367 5.968-4.993-2.877 10.367-5.968z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__x)",
    d: "m354.275 269.719 34.836-20.117c1.355-.784 1.355-2.068 0-2.853l-23.826-13.744c-1.356-.785-3.567-.785-4.922 0l-34.836 20.116c-1.355.785-1.355 2.069 0 2.854l23.826 13.744c1.356.784 3.567.784 4.922 0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__y)",
    d: "m354.275 269.719 34.836-20.117c1.355-.784 1.355-2.068 0-2.853l-23.826-13.744c-1.356-.785-3.567-.785-4.922 0l-34.836 20.116c-1.355.785-1.355 2.069 0 2.854l23.826 13.744c1.356.784 3.567.784 4.922 0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8DA5",
    d: "m325.527 254.287 34.836-20.117c1.355-.785 3.566-.785 4.922 0l23.826 13.744c.428.238.689.523.856.832.356-.689.095-1.45-.856-1.997l-23.826-13.744c-1.356-.785-3.567-.785-4.922 0l-34.836 20.116c-.951.547-1.212 1.308-.856 1.998.167-.309.452-.595.856-.832"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__z)",
    d: "m351.971 163.429-155.463 89.739c-1.712.975-4.28 1.094-5.754.238l-92.76-53.549c-1.474-.856-1.284-2.33.404-3.329l155.463-89.763c1.712-.975 4.28-1.094 5.755-.238l92.759 53.573c1.474.856 1.284 2.33-.404 3.329",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__A)",
    d: "m196.033 179.527 34.835-20.116c1.356-.785 1.356-2.069 0-2.854l-23.826-13.743c-1.355-.785-3.566-.785-4.922 0l-34.835 20.116c-1.355.785-1.355 2.069 0 2.853l23.826 13.744c1.355.785 3.567.785 4.922 0",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9198DB",
    d: "m167.283 164.071 34.835-20.117c1.356-.784 3.567-.784 4.922 0l23.826 13.744c.428.238.69.523.856.832.357-.689.096-1.45-.856-1.997l-23.826-13.744c-1.355-.784-3.566-.784-4.922 0l-34.835 20.117c-.951.547-1.213 1.307-.856 1.997.167-.285.452-.571.856-.832",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ADB1F2",
    d: "m151.97 210.937 129.188-74.592c.856-.5 1.926-.5 2.782 0l46.011 26.608a.983.983 0 0 1 0 1.712l-129.14 74.545a2.77 2.77 0 0 1-2.782 0l-46.059-26.584c-.666-.333-.666-1.308 0-1.689",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9198DB",
    d: "m151.971 212.673.452.262 128.736-74.331c.856-.5 1.926-.5 2.782 0l45.535 26.346.452-.261a.983.983 0 0 0 0-1.712l-46.011-26.608c-.856-.5-1.926-.5-2.782 0l-129.188 74.592c-.642.357-.642 1.332.024 1.712",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24126A",
    d: "m317.919 161.169-112.543 64.963 4.447 2.592 112.542-64.987zm-11.866-6.848-106.979 61.752 4.471 2.568L310.5 156.889zm-114.968 66.365-9.987 5.778 4.47 2.568 9.987-5.778zm8.822 8.608-6.943 4.018 4.446 2.569 6.967-4.019zm98.726-79.277-124.955 72.144 4.446 2.568 124.955-72.12zm-7.441-4.28-124.956 72.144 4.471 2.568 124.955-72.144zm-7.419-4.304-124.956 72.144 4.447 2.591 124.955-72.143z",
    opacity: 0.11
  })))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__B)",
    d: "M431.242 227.451c0 9.262-15.948 16.767-35.625 16.767s-35.626-7.505-35.626-16.767c0-9.261 15.949-16.766 35.626-16.766s35.625 7.505 35.625 16.766",
    filter: "url(#dAppRelease_svg__C)",
    opacity: 0.8
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M372.21 126.443c-3.536 2.55-10.753 3.777-14.842 4.33-.626.096-3.993.89-6.351 1.564-1.178.36-5.364-.939-5.917-1.348-3.272-2.477 1.515-5.676 1.515-5.676.313-2.55 6.615 2.838 8.997 1.876 5.292-2.213 7.192-3.801 10.343-5.124.265-.096.482-.265.65-.481z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "m371.321 119.347-14.072 5.798c-1.516.673.072 7.12 2.309 6.494 0 0 15.371-3.463 18.763-5.797.048-.024.096-.024.12-.048 3.416-2.959 10.801-13.663 10.801-13.663l-3.825-14.626c-.024.024-12.629 20.447-14.096 21.842"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9ACC0",
    d: "M347.41 128.392c.096-.024.168-.072.265-.12a.6.6 0 0 0 .072-.818l-10.729-9.165a.6.6 0 0 0-.818-.072.6.6 0 0 0-.072.818l10.729 9.165c.12.168.337.216.553.192"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2C6",
    d: "M406.439 225.214c-.793-2.719-2.862-4.499-4.666-3.969s-2.045 3.006-1.804 5.845c.048.529.336.986.577 1.419.481.914.697 1.949.673 2.983-.024.794.097 1.66.337 2.526.409 1.395 1.54 2.453 2.646 3.175 1.395.914 3.296.361 3.969-1.155.674-1.539 1.179-3.56.337-5.171-.433-.818-1.924-5.148-2.069-5.653m-18.378-4.859c-1.347 1.034-4.065 3.488-5.556 3.993-2.069.697-3.729.818-4.908.481-1.13-.313-1.226-2.165-.529-3.127.674-.938 7.914-7.914 7.914-7.914.072-.698-.264-1.853-.144-1.901 2.526-.914 6.374-.288 7 .914l-.072 4.475a2.27 2.27 0 0 1-1.444 2.068c-.914.385-1.972.794-2.261 1.011"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "m411.011 125.29-.169 9.02c-.024 1.371-3.824 89.509-3.824 89.509-.048 2.237-8.492 2.285-8.42-.601l-1.587-64.275-2.622-.987-2.165 55.688c-.096 2.694-9.309 1.78-8.876-.361l-.073-73.344c0-1.275.145-2.55.433-3.801z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D3E7",
    d: "m415.724 110.303-3.656 11.426-1.034 21.025c-1.323 7.769-27.159 5.027-26.99-5.124l.601-35.337c.096-6.014 4.474-8.636 8.901-8.107.962.12 1.924.385 2.838.794.361.144 3.079-1.299 3.44-1.106l7.144 4.282c.481.288.962.577 1.42.865 4.642 2.959 7.433 5.701 7.336 11.282"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "m404.491 87.812-.169 10.007c-.048.432-.312.841-.842 1.178-1.347.842-3.824.962-5.58.289-1.035-.41-1.564-.986-1.564-1.612l.144-8.034 3.873-4.835h.409zm1.226 77.456.241-3.921c.12-.529.313-1.01.577-1.491l.529-.89c.602-.986.89-2.141.89-3.296l-.24-21.745a22 22 0 0 0-.072-2.526c-.361-3.801-1.107-14-1.275-17.127a1.41 1.41 0 0 1 1.347-1.492l5.99-.216a1.427 1.427 0 0 1 1.467 1.395v18.185c0 .674-.024 1.348-.096 2.021l-2.646 23.502c.12.818.505 2.189.866 3.464a7.9 7.9 0 0 1-.145 4.835c-.649 1.804-1.708 3.921-3.127 3.993-1.852.096-2.285-6.23-2.285-6.23s-.193 1.539-.361 2.068c-.192.602-.794 1.179-1.251 1.011-.625-.169-.673-.746-.409-1.54"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M380.99 142.32c-.049 3.296 5.147 7.313 5.845 6.832.746-.505-.265-20.784 1.636-34.11.962-6.712 2.477-12.87 4.883-16.67 1.179-1.853 3.031-3.392 3.031-3.392s-.577-.24-.866-.337c-2.189-.698-4.234-.866-6.928.385-2.622 1.227-4.595 3.295-4.667 7.168l-.938 14.77zm30.069 7.289 1.01-27.88 5.052-10.825c.096-5.581-4.065-8.948-8.732-11.883-.457-.289-.938-.577-1.419-.866l-2.622-1.564.192 1.54c.361 2.67-5.196 12.99-6.952 20.038-2.309 9.285-3.897 33.581-3.391 33.989.89.794 16.092 1.901 16.862-2.549"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M404.852 114.945c.168 3.176 1.274 15.011 1.539 17.777.072.746.096 1.516.072 2.285l.193 19.341c-.097 1.996 7.12 2.405 7.312.649l2.286-19.557c.072-.721.12-1.419.096-2.117l.77-22.395z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2BBBF",
    d: "M404.492 87.812v.481c-.072 3.8-3.247 6.976-7.024 6.663a7 7 0 0 1-.866-.12.7.7 0 0 0-.216-.048l.096-5.124 3.873-4.835.168-.192.241.192z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M393.234 78.046c-1.949 3.055-3.416 8.924-1.852 12.195.962 2.021 2.405 3.104 4.45 3.224.794.048 4.57-.36 7.264-2.069 1.756-1.13 3.2-2.526 4.138-3.945 3.295-4.931 2.069-10.03-1.876-12.7-7.217-4.908-9.502-.819-12.124 3.295"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#343C6B",
    d: "M412.478 81.99c-.313 3.705-3.103 7.938-8.083 9.935l.024-1.997c.65-.577 1.275-1.227 1.588-2.117.192-.529-.674-.866-1.54-.553-.024 0-.096.024-.12.024-.385.169-.962.12-1.539 0-.939-.168-1.444-1.203-1.059-2.069 2.718-6.11-4.474-7.673-6.23-9.718-.794.722-2.333 2.55-2.333 2.55.216-.89.793-1.9 1.226-2.983a6.66 6.66 0 0 1 7.073-3.993c.481.072.962.168 1.491.289 7.241 1.876 9.814 6.976 9.502 10.632"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M402.879 86.777c-1.419 1.203-1.924 2.935-1.13 3.85.793.913 2.574.673 3.993-.53s1.924-2.935 1.13-3.849c-.793-.914-2.573-.698-3.993.53z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "m268.784 105-29.87 16.551L199 143.669 206.5 196l68-39.5z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__D)",
    d: "m268.784 105-29.87 16.551L199 143.669 206.5 196l68-39.5z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C9F5",
    d: "m326.784 104-29.894 16.551L257 142.669l6.5 49.831 69.5-39z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dAppRelease_svg__E)",
    d: "m326.784 104-29.894 16.551L257 142.669l6.5 49.831 69.5-39z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__a",
    x1: 254.127,
    x2: 408.98,
    y1: 104.817,
    y2: 104.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__b",
    x1: 285.261,
    x2: 296.296,
    y1: 114.829,
    y2: 68.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__c",
    x1: 344.424,
    x2: 344.424,
    y1: 49,
    y2: 118.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__d",
    x1: 297.951,
    x2: 390.9,
    y1: 83.891,
    y2: 83.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__e",
    x1: 344.425,
    x2: 390.9,
    y1: 67.09,
    y2: 67.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__f",
    x1: 297.953,
    x2: 344.427,
    y1: 67.09,
    y2: 67.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__g",
    x1: 297.951,
    x2: 390.9,
    y1: 77.121,
    y2: 77.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__h",
    x1: 344.425,
    x2: 390.9,
    y1: 93.924,
    y2: 93.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__i",
    x1: 297.953,
    x2: 344.427,
    y1: 93.925,
    y2: 93.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__j",
    x1: 23.127,
    x2: 177.98,
    y1: 240.817,
    y2: 240.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__k",
    x1: 54.261,
    x2: 65.296,
    y1: 250.829,
    y2: 204.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__l",
    x1: 113.424,
    x2: 113.424,
    y1: 185,
    y2: 254.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__m",
    x1: 66.951,
    x2: 159.9,
    y1: 219.891,
    y2: 219.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__n",
    x1: 113.424,
    x2: 159.899,
    y1: 203.09,
    y2: 203.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__o",
    x1: 66.953,
    x2: 113.427,
    y1: 203.09,
    y2: 203.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__p",
    x1: 66.951,
    x2: 159.9,
    y1: 213.121,
    y2: 213.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__q",
    x1: 113.424,
    x2: 159.899,
    y1: 229.924,
    y2: 229.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__r",
    x1: 66.953,
    x2: 113.427,
    y1: 229.925,
    y2: 229.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__s",
    x1: 194.995,
    x2: 451.241,
    y1: 245.353,
    y2: 245.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#5C66D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#6A73DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#8289E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#A3A7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__t",
    x1: 197.683,
    x2: 254.576,
    y1: 279.881,
    y2: 133.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__u",
    x1: 281.094,
    x2: 537.477,
    y1: 236.808,
    y2: 236.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__v",
    x1: 323.13,
    x2: 323.13,
    y1: 162.808,
    y2: 310.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__w",
    x1: 309.108,
    x2: 309.108,
    y1: 176.704,
    y2: 280.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__x",
    x1: 324.511,
    x2: 390.139,
    y1: 251.363,
    y2: 251.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__y",
    x1: 357.319,
    x2: 357.319,
    y1: 232.417,
    y2: 270.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__z",
    x1: 183.143,
    x2: 439.526,
    y1: 179.981,
    y2: 179.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__A",
    x1: 166.269,
    x2: 231.896,
    y1: 161.162,
    y2: 161.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__D",
    x1: 268.721,
    x2: 230.209,
    y1: 196.415,
    y2: 93.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dAppRelease_svg__E",
    x1: 295,
    x2: 295,
    y1: 104,
    y2: 192.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dAppRelease_svg__B",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 16.7664 -35.6255 0 395.617 227.451)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10134A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10134A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "dAppRelease_svg__C",
    width: 79.251,
    height: 41.533,
    x: 355.991,
    y: 206.685,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_16_43649",
    stdDeviation: 2
  })))));
};
export default SvgDAppRelease;